/**
 * @Description 拓店日志弹出窗
 */
import { FC, useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import V2LogRecord from '@/common/components/SpecialBusiness/V2LogRecord';
import styles from './index.module.less';
import { post } from '@/common/request';
import V2Empty from '@/common/components/Data/V2Empty';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';


interface ExpandShopLogProps{
  visible?:any
  hideModal:()=> void,
  footer?:any
  maskClosable?:any
  modelClusterId:any
  title?:any
  width?:any
}

const ExpandShopLog:FC<ExpandShopLogProps> = ({
  visible = false,
  hideModal,
  footer = false,
  maskClosable = false,
  title,
  width,
  modelClusterId
}) => {

  const [items, setItems] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const getTaskLogs = () => {
    setLoading(true);
    post('/direct/task/logs', { modelClusterId }).then((res) => {
      const result = res?.map((item) => {
        return {
          ...item,
          id: item.id,
          name: item.operateTime,
          description: <V2DetailItem className={styles.descriptionLog} type='text' value={item.msg}></V2DetailItem>,
          status: 'finish',
        };
      });
      setItems(result);
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    if (visible) {
      getTaskLogs();
    }
  }, [visible]);
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={hideModal}
      maskClosable={maskClosable}
      footer={footer}
      width={width}
      zIndex={1100}
    >
      <Spin spinning={loading}>
        <div style={{ marginTop: '-15px' }}>
          {items.length
            ? <div style={{
              maxHeight: '600px',
              overflow: 'auto'
            }}>
              <V2LogRecord items={items}></V2LogRecord>
            </div>
            : <V2Empty />
          }
        </div>
      </Spin>
    </Modal>
  );
};

export default ExpandShopLog;
